import { combineReducers } from "redux";
import DummyReducer from "./dummyReducer";
import StatReducer from "./statReducer";
import WalletReducer from "./walletReducer";

export default combineReducers({
    dummy: DummyReducer,
    stat: StatReducer,
    wallet: WalletReducer
})